import Route from "@ember/routing/route";

class Model {
  save() {
    // do nothing
  }
}

export default class extends Route {
  override model(): Model {
    return new Model();
  }
}
